import script from "./LawFirmInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./LawFirmInformation.vue?vue&type=script&setup=true&lang=js"

import "./LawFirmInformation.vue?vue&type=style&index=0&id=f7661e50&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7661e50"]])

export default __exports__